import React, { Component } from 'react';

class Heading extends Component {

  constructor(props) {
    super(props);
    this.state = {
      wordDb: [
        "Collaboratively Draft Policy",
        "Democratically Write Text",
        "Vote on Policy Wording Edits",
        "Come to an Agreement",
      ],
      time: 2000
    }
    this.wordi = 0;

  }



  changeText() {

  	document.getElementById("textRotator").innerHTML = this.state.wordDb[this.wordi];
  	if (this.wordi < this.state.wordDb.length - 1) {
  		this.wordi++;
  	} else {
  		this.wordi = 0;
  	}
    this.myTimeout = setTimeout(() => {this.changeText()}, this.state.time);

  }


  componentDidMount() {
    this.changeText();
  }

  componentWillUnmount() {
    clearTimeout(this.myTimeout);
  }

  render() {

    return (
      <h1 id="heading">
        DemDoc is an App to
        &nbsp;<span id="textRotatorBox">
          <span id="textRotator"></span>
        </span>
      </h1>
    );
  }
}
export default Heading;
